export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: '低価格で高品質',
      description: '月額5,000円から始められる手頃な価格設定。初期費用も10,000円のみで、プロフェッショナルなWebサイトを手に入れることができます。'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '充実したサポート',
      description: '専門スタッフが丁寧にサポート。初心者の方でも安心してご利用いただけます。月に複数回の修正依頼も可能です。'
    },
    {
      icon: 'ri-speed-up-line',
      title: '迅速な対応',
      description: '最短48時間以内に対応。お急ぎの場合は緊急対応オプションもご用意しています。'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'レスポンシブデザイン',
      description: 'スマートフォン、タブレット、PCなど、あらゆるデバイスで美しく表示されるWebサイトを制作します。'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'SEO対策',
      description: '検索エンジンで上位表示されやすいように、基本的なSEO対策を施します。アクセスレポートも定期的に提供します。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心の運用管理',
      description: 'Webサイトの運用・管理もお任せください。セキュリティ対策やバックアップも万全です。'
    }
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            選ばれる理由
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            NOARE websiteが多くのお客様に選ばれる6つの理由
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-4 sm:mb-6">
                <i className={`${benefit.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
                {benefit.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}